export enum NOTIFICATION {
  Error = "error",
  Warning = "warning",
  Success = "success",
  Information = "info",
}
